import React, {useState, useEffect, useRef} from 'react'
import { Box, Divider, Typography, useMediaQuery } from '@mui/material'
import { SectionTitle, ScrollFadeIn, ScrollFadeInSlideUp } from '../../../components'
import { motion } from 'framer-motion'

//import icons
import HealthAndSafetyOutlinedIcon from '@mui/icons-material/HealthAndSafetyOutlined';
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import RecyclingOutlinedIcon from '@mui/icons-material/RecyclingOutlined';
import RecommendOutlinedIcon from '@mui/icons-material/RecommendOutlined';

// import assets
import { about1, about2, about3, about4 } from '../../../assets';

const AboutCommitment = () => {
    const iconSize = '5rem'
    const isSmallScreen = useMediaQuery('(max-width: 762px)'); // Detect screen width
  const aboutIcons = [
    {name:'Safety', icon:<HealthAndSafetyOutlinedIcon sx={{ fontSize: `${iconSize}`}}/>, text:"Safety first, always. We prioritize our people, ensuring zero compromises and zero incidents. Excellence starts with a secure, industry-leadng workplace.", img:about1},
    {name:'Quality', icon:<CheckBoxOutlinedIcon sx={{ fontSize: `${iconSize}`}}/>, text:"Consistency drives excellence. we commit to every project, anticipating challenges and delivering solutions that go beyond expectations.", img:about2},
    {name:'Sustainability', icon:<RecyclingOutlinedIcon sx={{ fontSize: `${iconSize}`}}/>, text:`We go beyond sustainable construction, embracing a holistic approach to corporate social responsibility\u2014focusing on ourpartners, people, projects, practices, and the communities we serve.`, img:about3},
    {name:'Satisfaction', icon:<RecommendOutlinedIcon sx={{ fontSize: `${iconSize}`}}/>, text:"our primary goal is to ensure that our clients are fully satisfied and delighted with the results of our projects, delivering excellence that exceeds expectations.", img:about4},
  ]

  const AboutIconImage = ({img, index}) => {
    return (
      
      <Box
        sx={{
          width:'50%',
          
          justifyContent:index % 2 === 0? 'right' : 'left',
          boxSizing:'border-box',
          overflow:'hidden',
          alignItems:'center',
          display:'flex',
          '@media screen and (max-width:762px)':{
            width:'100%'
          }
        }}
      >
        <Box
          component='img'
          src={img}
          sx={{
            objectFit:'contain',
            objectPosition:'center center',
            // minHeight:'inherit',
            // padding:'2rem',
            width:'100%',
            height:'100%,',
            boxSizing:'border-box',
            alignItems:'center'
          }}
        />
      </Box>
    )
  }

  const AboutIconText = ({name, text, icon}) => {
    return(
      <Box
        sx={{
          width:'50%',
          display:'flex',
          flexDirection:'column',
          alignItems:'center',
          paddingX:'5rem',
          textAlign:'center',
          boxSizing:'border-box',
          '@media screen and (max-width:762px)':{
            width:'100%',
            marginY:'1rem',
            paddingX:'2rem',
          }
        }}
      >
        <Box>
          <Typography variant='h1'
            sx={{
              fontSize:'2rem',
              fontFamily:`var(--title-font)`,
            }}
          >{name}</Typography>
        </Box>
        <Box
          sx={{
            marginY:'0.5rem'
          }}
        >{icon}</Box>
        <Box
          sx={{
            fontFamily:'var(--text-font)',
            textTransform:'',
            fontSize:'1.2rem',
            '@media screen and (max-width: 762px)':{
              fontSize:'1rem'
            }
          }}
        >{text}</Box>
      </Box>
    )
  }


  return (
    <Box 
            sx={{
              // paddingY:'2rem',
              // background:'linear-gradient(to right, #A6A6A6, #fefefe)',
              // backgroundImage: `url(${wide})`,
              background:'linear-gradient(to right, #A6A6A6, #fefefe)',
              backgroundPosition:'center center',
              backgroundAttachment:'fixed',
              backgroundSize:'cover',
              display:'flex',
              flexDirection:'column',
              width:'100%',
              justifyContent:'center'
            }}
          >
            <SectionTitle 
              firstTitleWord='our'
              secondTitleWord='commitments'
              sx={{
                '@media screen and (max-width:762px)':{
                  paddingY:'2rem'
                }
              }}
            />

            <Box
              sx={{
                display:'flex',
                flexDirection:'column',
              }}
            >
              <Typography
                variant='h1'
                sx={{
                  fontSize:'2.5rem',
                  fontFamily:"ITC Avant Garde Gothic",
                  fontWeight:'1000',
                  width:'80%',
                  marginX:'auto'
                }}
              >
                Every choice shapes the future.
              </Typography>

              <Typography
                sx={{
                  fontFamily:'Gotham',
                  textTransform:'',
                  fontSize:'1.2rem',
                  width:'50%',
                  alignSelf:'flex-end',
                  textAlign:'right',
                  marginY:'5rem',
                  paddingX:'3rem',
                  '@media screen and (max-width:762px)':{
                    marginY:'2rem',
                    width:'80%',
                    fontSize:'1rem'
                  }
                }}
              >
                Built for success, driven by excellence. saftey, quality, sustainability, and community impact are at our core. at pangu, we don't just build&#8212;we create lastng value with innovation and integrity. your vision, our commitment&#8212;together, we build with purpose.
              </Typography>
            </Box>
            <Divider />
            <Box //icons
              sx={{
                display:'flex',
                flexDirection:'column',
                marginY:'2rem'
              }}
            >
                {aboutIcons.map((item, index) => (
              <ScrollFadeInSlideUp direction='left' threshold='0.8'>
                  <Box
                    
                    sx={{
                      display:'flex',
                      flexDirection:'row',
                      // padding:"2rem",
                      alignItems:'center',
                      marginX:'auto',
                      marginY:'1rem',
                      boxSizing:'border-box',
                      '@media screen and (max-width: 762px)':{
                        flexDirection:'column'
                      }
                    }}
                  >
                    {isSmallScreen ? (
                      // Always render <Image><IconText> on small screens
                      <>
                        <AboutIconImage img={item.img} />
                        <AboutIconText name={item.name} text={item.text} icon={item.icon} />
                      </>
                    ) : (
                      // Alternate layout based on index for larger screens
                      index % 2 === 0 ? (
                        <>
                          <AboutIconImage img={item.img} />
                          <AboutIconText name={item.name} text={item.text} icon={item.icon} />
                        </>
                      ) : (
                        <>
                          <AboutIconText name={item.name} text={item.text} icon={item.icon} />
                          <AboutIconImage img={item.img} />
                        </>
                      )
                    )}
                  </Box>
              </ScrollFadeInSlideUp>
                ))}
              </Box>
            </Box>
  )
}

export default AboutCommitment